export class Category {
  constructor(
    private id: CategoryId,
    public name: string,
    public icon?: string
  ) { }

  public getId(): CategoryId {
    return this.id;
  }
}

export type CategoryId = string;



// WEBPACK FOOTER //
// /dist/src/app/question/category.model.ts